import { dataUnlink } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUnlink = /*#__PURE__*/createIcon(dataUnlink)
export default IconUnlink
